/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/global.css'
import { injectSpeedInsights } from '@vercel/speed-insights'

// Register Service Worker for API caching
export const onClientEntry = () => {
  // Initialize Vercel Speed Insights (production only)
  if (process.env.NODE_ENV === 'production') {
    try { injectSpeedInsights() } catch {}
  }
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then(() => navigator.serviceWorker.ready)
        .then((reg) => {
          try {
            const zone = localStorage.getItem('waktu_zone') || 'WLY01'
            let coords = null
            const raw = localStorage.getItem('waktu_coords')
            if (raw) coords = JSON.parse(raw)
            const sw = reg.active || navigator.serviceWorker.controller
            if (sw) {
              sw.postMessage({ type: 'PRECACHE', zone, coords })
            }
          } catch {}
        })
        .catch(() => {})
    })
  }
}

function setDynamicManifestHref(pathname, search, hash) {
  try {
    const path = `${pathname || '/'}${search || ''}${hash || ''}`
    const href = `/api/manifest?path=${encodeURIComponent(path)}`
    let link = document.querySelector('link[rel="manifest"]')
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'manifest')
      document.head.appendChild(link)
    }
    if (link.getAttribute('href') !== href) {
      link.setAttribute('href', href)
    }
  } catch {}
}

// Ensure manifest points to current page at first render
export const onInitialClientRender = () => {
  try {
    setDynamicManifestHref(window.location.pathname, window.location.search, window.location.hash)
  } catch {}
}

// Update manifest on every client-side route change
export const onRouteUpdate = ({ location }) => {
  setDynamicManifestHref(location.pathname, location.search, location.hash)
}
